import cx from 'classnames';
import { format } from "date-fns";
import { useFormikContext } from "formik";
import React, { useEffect, useState } from 'react';
import { AlertTriangle, Check, X } from "react-feather";
import { connect } from 'react-redux';
import { Loader } from "../../components/Loader";
import { TickCross } from '../../components/TickCross';
import { appointmentStatus, cancellationReasons, howOften, marketing, notificationChoreType, recallFilter, scheduleTypes, when_Automated, when_Magntitude, when_MagntitudeBig, when_MagntitudeForever, when_OneOff, appointmentCountEquality } from '../../constants';
import { EVO } from '../../EVO';
import * as actions from "../../redux/notificationchores";
import { urls } from "../../urls";
import './Summary.css';

const NCDS = (props) => {
    const [loading, setLoading] = useState(true);
    const [quote, setQuote] = useState(null);
    const { values, setFieldValue } = useFormikContext();
    
    useEffect(() => {
        if (values.scheduleTypeId === scheduleTypes.OneOff.value && props.getQuote && !quote) {
            EVO.post(urls.api.notificationchores.quote.url, values).then(r => {
                setLoading(false);
                if (r) {
                    setQuote(r);
                    setFieldValue('quote', r.credits);
                }
                else {
                    throw new Error('Invalid response');
                }
            }).catch(e => EVO.alert(e));
        }
    }, [values]);


    const filters = () => {
        const practs = EVO.any(values.practitioners) ? EVO.getSelectItemFromObject(props.practitioners, p => p.label, p => p.id) : [];
        const appTypes = EVO.any(values.appointmentTypes) ? EVO.getSelectItemFromObject(props.appointmentTypes, p => p.name, p => p.id) : [];
        const businesses = EVO.any(values.businesses) ? EVO.getSelectItemFromObject(props.businesses, p => p.name, p => p.id) : [];
        const canReasons = EVO.any(values.cancellationReasons) ? EVO.getSelectItemFromObjectOfSelectItems(cancellationReasons) : [];
        const billableItems = EVO.any(values.billableItems) ? EVO.getSelectItemFromObject(props.billableItems, p => p.name, p => p.id) : [];
        const products = EVO.any(values.products) ? EVO.getSelectItemFromObject(props.products, p => p.name, p => p.id) : [];

        return <div>
            <div className="ncd-summary-filter-table">
                {EVO.any(values.businesses) &&
                    <FilterDisplay name="Businesses" items={values.businesses.map(c => EVO.getPropertyNameFromListValue(businesses, c))} includeExclude={values.businessExclude} />}

            {EVO.any(values.appointmentCategories) &&
                <FilterDisplay name="Appointment Categories" items={values.appointmentCategories} includeExclude={values.appointmentCategoryExclude} />}

            {EVO.any(values.appointmentTypes) &&
                <FilterDisplay name="Appointment Types" items={values.appointmentTypes.map(c => EVO.getPropertyNameFromListValue(appTypes, c))} includeExclude={values.appointmentTypeExclude} />}

            {EVO.any(values.sexes) &&
                <FilterDisplay name="Sex" items={values.sexes} includeExclude={values.sexesExclude} />}

            {EVO.any(values.cancellationReasons) &&
                <FilterDisplay name="Cancellation Reason" items={values.cancellationReasons.map(c => EVO.getPropertyNameFromListValue(canReasons, c))} includeExclude={values.cancellationReasonsExclude} />}

            {EVO.any(values.practitioners) &&
                    <FilterDisplay name="Practitioners" items={values.practitioners.map(c => EVO.getPropertyNameFromListValue(practs, c))} includeExclude={values.practitionerExclude} />}

            {EVO.any(values.medicalAlerts) &&
                    <FilterDisplay name="Medical Alerts" items={values.medicalAlerts} includeExclude={values.medicalAlertsExclude} />}

            {EVO.any(values.products) &&
                    <FilterDisplay name="Products" items={values.products.map(c => EVO.getPropertyNameFromListValue(products, c))} includeExclude={values.productsExclude} />}

            {EVO.any(values.billableItems) &&
                    <FilterDisplay name="Billable Items" items={values.billableItems.map(c => EVO.getPropertyNameFromListValue(billableItems, c))} includeExclude={values.billableItemsExclude} />}

            {EVO.isNumber(values.appointmentCount) && values.whenAutomatedId !== when_Automated.OnCount.value &&
                    <FilterDisplay name="Appointment Count"
                    content={`Only sends if the patient has shown up to ${EVO.getPropertyNameFromObjectValue(appointmentCountEquality, values.appointmentCountEqualityId).toLocaleLowerCase()} ${values.appointmentCount} appointments${(values.appointmentCountApplyFilters ? ' matching the filters above' : '')}`} />}
        </div>

            {values.scheduleTypeId === scheduleTypes.OneOff.value && (<div>
                {values.oneOffFrom.substring(0, 11) === values.oneOffTo.substring(0, 11) ?
                    <div>Appointment is on {EVO.format(values.oneOffFrom, 'do MMM yyyy')}</div> :
                    <div>Appointment is between {EVO.format(values.oneOffFrom, 'do MMM yyyy')} and {EVO.format(values.oneOffTo, 'do MMM yyyy')}</div>}
            </div>)}
        </div>
    };

    const FilterDisplay = ({ name, items, content, includeExclude }) => {
        return <div className="ncd-summary-filter">
            <span className="ncd-summary-filter-name">{name}:</span>
            <span>
                {EVO.any(items) && items.map(a => <span key={a} className={cx('ncd-summary-filter-item', {
                    include: !includeExclude,
                    exclude: includeExclude
                })}>{!includeExclude ? <Check size={15} /> : <X size={15} />}<span className="ncd-summary-filter-item-name">{a}</span></span>)}
                {content}
            </span>
        </div>
    };

    return (<div className="ncd-summary-wrapper">
        <div className="ncd-summary">
        {props.showModified && values.modifiedAt && <div className="nc-title">Saved: {EVO.format(values.modifiedAt, 'dd/MM/yyyy HH:mm')} {props.timezone && ` (${props.timezone})`}</div>}
        {props.showActive && SummaryRow('Active', <TickCross bool={values.active} />)}
        {values.notificationType === notificationChoreType.Sms && SummaryRow('SMS name', values.name)}
        {values.notificationType === notificationChoreType.Email && SummaryRow('Transactional Email Name', values.name)}
        {values.notificationType === notificationChoreType.Sms && SummaryRow('Marketing message?', EVO.getPropertyNameFromObjectValue(marketing, values.marketing))}
        {values.notificationType === notificationChoreType.Sms && SummaryRow('SMS Type', EVO.getPropertyNameFromObjectValue(scheduleTypes, values.scheduleTypeId))}
        {SummaryRow('Filters', EVO.choreHasFilters(values, true) ? filters() : <div className="ncd-summary-no-filters">No filters applied</div>)}
        {values.scheduleTypeId === scheduleTypes.OneOff.value &&
            SummaryRow('When to send', <div>
                {EVO.getPropertyNameFromObjectValue(when_OneOff, values.whenOneOffId)}
                {values.whenOneOffId === when_OneOff.Scheduled.value && <span>:&nbsp;{format(new Date(values.whenOneOffDateTime), 'dd/MM/yyyy HH:mm')}</span>}
            </div>)}
        {values.scheduleTypeId === scheduleTypes.Recurring.value && <div>
            {SummaryRow('When to send', <WhenToSend />)}
            {SummaryRow('How often', EVO.getPropertyNameFromObjectValue(howOften, values.howOftenId))}
        </div>}
        {values.notificationType === notificationChoreType.Sms && SummaryRow('SMS content', values.messageTemplate)}
        {values.notificationType === notificationChoreType.Email && SummaryRow('Email Template', <div>{EVO.getPropertyNameFromListValue(props.cmEmails, values.cmEmailId)} {values.attachIcsFile && <span>with .ics calendar file</span>}</div>)}
        {values.notificationType === notificationChoreType.Sms && values.scheduleTypeId === scheduleTypes.OneOff.value && props.getQuote && SummaryRow("Approx. cost", <div>
            <Loader loading={loading}>
                {quote ? <div>This would use approximately {quote.credits} credits, sending to {quote.appointments} people.</div> :
                    <div>Error retrieving quote</div>}
            </Loader>
        </div>)}
        {values.notificationType === notificationChoreType.Email && values.scheduleTypeId === scheduleTypes.OneOff.value && props.getQuote && SummaryRow("Approx. count", <div>
            <Loader loading={loading}>
                {quote ? <div>This would send to approximately {quote.appointments} people.</div> :
                    <div>Error retrieving quote</div>}
            </Loader>
        </div>)}
            
        </div>
        {quote && quote.credits && quote.clientCredits < quote.credits && <div className="quote-insufficient">
            <div className="pt-input-error"><AlertTriangle color="#e80c4d" />You don't have enough credits to send this SMS now. You can save it as a draft by clicking the finish button, then top up and edit the SMS to send it</div>
        </div>}
    </div>);
}

const WhenToSend = () => {
    const { values } = useFormikContext();

    var retVal = '';
    if (values.whenAutomatedId === when_Automated.OnCount.value) {
        const appCountDescriptor = EVO.numberDescriptor(values.appointmentCount);
        retVal = `1 hour after a patients ${appCountDescriptor} appointment `;
        if (values.whenMagnitudeId === when_MagntitudeForever.Forever.value) {
            retVal += 'over all time ';
        }
        else {
            const magnitudeDescriptor = EVO.dePloralise(EVO.getPropertyNameFromObjectValue(when_MagntitudeBig, values.whenMagnitudeId), values.whenAutomatedMagnitudeValue);
            retVal += `in the last ${values.whenAutomatedMagnitudeValue} ${magnitudeDescriptor} `.toLocaleLowerCase();
        }
        retVal += `with a status of "${EVO.getPropertyNameFromListValue(EVO.getSelectItemFromObjectOfSelectItems(appointmentStatus), values.appointmentStatus)}"`;
    }
    else {
        const magnitudeDescriptor = EVO.dePloralise(EVO.getPropertyNameFromObjectValue(when_Magntitude, values.whenMagnitudeId), values.whenAutomatedMagnitudeValue);
        const whenDescriptor = EVO.getPropertyNameFromObjectValue(when_Automated, values.whenAutomatedId);
        retVal = `${values.whenAutomatedMagnitudeValue} ${magnitudeDescriptor} ${whenDescriptor}`.toLowerCase().replace('dna', 'DNA');
    }

    if (values.requiresUpcomingAppointmentsCheck) {
        retVal += ` if they have no upcoming appointment ${EVO.getPropertyNameFromObjectValue(recallFilter, values.recallFilter).toLowerCase()}`;
    }

    if (values.isReminder) {
        retVal += ` if the patient has reminders enabled`;
    }

    if (values.isConfirmation) {
        retVal += ` if the patient has confirmations enabled`;
    }

    return <span> {retVal}</span>
};

const SummaryRow = (name, value) => {
    return (<div className="ncd-summary-row">
        <div className="ncd-summary-name">{name}</div>
        <div className="ncd-summary-value">{value}</div>
    </div>);
}

const mapStateToProps = ({ ensure }) => ({
    appointmentTypes: ensure.appointmentTypes,
    practitioners: ensure.practitioners,
    businesses: ensure.businesses,
    medicalAlerts: ensure.medicalAlerts,
    billableItems: ensure.billableItems,
    products: ensure.ptProducts,
    cmEmails: ensure.cmEmails
});

export const NCDSummary = connect(mapStateToProps, actions)(NCDS);


// WEBPACK FOOTER //
// ./src/pages/NotificationChore/Summary.js